import { render, staticRenderFns } from "./compare-value.vue?vue&type=template&id=1663a226&"
import script from "./compare-value.vue?vue&type=script&lang=js&"
export * from "./compare-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports